import api from './axios'; 

const rolesRequest = {
    getAll(){
        return api.get('/roles')
    },
    save(form){
        return api.post('/roles',form)
    },
    update(id,form){
        return api.patch(`/roles/${id}`,form)
    },
    delete(id){
        return api.delete(`/roles/${id}`)
    }
}

export default rolesRequest